import { z } from 'zod';

import { INVITATION_STATUS } from '../enums';

import { emailSchema, idSchema } from './common';

export const invitationSummarySchema = z.object({
  id: idSchema,
  email: emailSchema,
  roleId: idSchema,
  roleName: z.string(),
  status: z.enum([
    INVITATION_STATUS.PENDING,
    INVITATION_STATUS.ACCEPTED,
    INVITATION_STATUS.EXPIRED,
    INVITATION_STATUS.REVOKED,
  ]),
  invitedByName: z.string(),
  expiresAt: z.string(),
  createdAt: z.string(),
});
export type InvitationSummary = z.infer<typeof invitationSummarySchema>;

export const createInvitationInputSchema = z.object({
  email: emailSchema,
  roleId: idSchema,
});
export type CreateInvitationInput = z.infer<typeof createInvitationInputSchema>;

export const publicInvitationInfoSchema = z.object({
  organizationName: z.string(),
  roleName: z.string(),
  inviteeEmail: emailSchema,
  expiresAt: z.string(),
});
export type PublicInvitationInfo = z.infer<typeof publicInvitationInfoSchema>;
